import { RtFraction } from "@aprao/common/src/runtypes/common.js";
import { z } from "zod";

export const TimelineDistributionMethodSchema = z.enum([
  "linear",
  "quarterly",
  "s-curve",
  "manual",
]);

const TimelineFrameRangeSchema = z.object({
  lower: z.number().int().min(0).nullable(),
  upper: z.number().int().min(0).nullable(),
});

const TimelineDistributionSchema = z.array(
  z.tuple([
    // offset
    z.number().int().min(0),
    // ratio
    RtFraction,
  ]),
);

export const TimelineOverrideSchema = z.object({
  distributionMethod: TimelineDistributionMethodSchema.nullable(),
  frameRange: TimelineFrameRangeSchema,
  distribution: TimelineDistributionSchema,
});

export const WithTimelineOverrideSchema = z.object({
  timelineOverride: TimelineOverrideSchema,
});

export const TimelineStageSchema = z.object({
  distributionMethod: TimelineDistributionMethodSchema,
  frameRange: TimelineFrameRangeSchema,
});
